export default __webpack_public_path__ + "static/media/Icon-open-external-link.76cd0b10.svg";